import React from "react";
import {
  Button,
  Container,
  Typography,
} from "@material-ui/core";

interface CampaignBannerProps {
  image: string;
  discount: string;
  title: string;
  description: string;
  buttonText?: string;

  // Right promotional card
  sideImage?: string;
  sideDiscount?: string;
  sideTitle?: string;
  sideSubtitle?: string;
  sideButtonText?: string;
}

const CampaignBanner: React.FC<CampaignBannerProps> = ({
  image,
  discount,
  title,
  description,
  buttonText = "JOIN NOW",

  sideImage,
  sideDiscount = "%30",
  sideTitle = "Fresh Fruit",
  sideSubtitle = "Save Up to Flate",
  sideButtonText = "SHOP NOW",
}) => {
  return (
    <section className="campaign-section">
      <Container maxWidth="lg">

        <div className="campaign-layout">

          {/* =========================================
              LEFT CAMPAIGN BANNER
          ========================================= */}

          <div
            className="campaign-main"
            style={{
              backgroundImage: `url(${image})`,
            }}
          >
            {/* Light image overlay */}
            <div className="campaign-main-overlay" />

            <div className="campaign-content">

              {/* Discount */}
              <Typography className="campaign-discount">
                {discount}
              </Typography>

              {/* Title */}
              <Typography
                component="h2"
                className="campaign-title"
              >
                {title.split("#No_plastic").map(
                  (part, index, array) => (
                    <React.Fragment key={index}>
                      {part}

                      {index < array.length - 1 && (
                        <span className="campaign-highlight">
                          #No_plastic
                        </span>
                      )}
                    </React.Fragment>
                  )
                )}
              </Typography>

              {/* Description */}
              <Typography className="campaign-description">
                {description}
              </Typography>

              {/* Button */}
              <Button className="campaign-button">
                {buttonText}
              </Button>

            </div>
          </div>

          {/* =========================================
              RIGHT PROMO CARD
          ========================================= */}

          {sideImage && (
            <div
              className="campaign-side"
              style={{
                backgroundImage: `url(${sideImage})`,
              }}
            >

              <div className="campaign-side-overlay" />

              <div className="campaign-side-content">

                <Typography className="campaign-side-discount">
                  {sideDiscount}
                </Typography>

                <Typography className="campaign-side-subtitle">
                  {sideSubtitle}
                </Typography>

                <Typography className="campaign-side-title">
                  {sideTitle}
                </Typography>

                <Button className="campaign-side-button">
                  {sideButtonText}
                </Button>

              </div>
            </div>
          )}

        </div>

      </Container>
    </section>
  );
};

export default CampaignBanner;